module.exports = __webpack_public_path__ + "static/9-b2a68f23815921b981d86a4b131aac70.png";